import { render, staticRenderFns } from "./DiscoverRealTimeTopicsFrequencyTable.vue?vue&type=template&id=2d1a5047&scoped=true&"
import script from "./DiscoverRealTimeTopicsFrequencyTable.vue?vue&type=script&lang=js&"
export * from "./DiscoverRealTimeTopicsFrequencyTable.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverRealTimeTopicsFrequencyTable.vue?vue&type=style&index=0&id=2d1a5047&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a5047",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
